export default {
  API_ROOT: '//api.shuziwenbo.cn',
  COMMUNITY_ROOT: '//community.shuziwenbo.cn',
  UPLOAD_ROOT: '//upload.szwb.imgo.tv',
};

export function getCommParams() {
  return {
    platform: 'pcweb',
  };
}

export function getCommUserParams() {
  return {
    token: JSON.parse(localStorage.getItem('sh-userInfo')).token || '',
    uid: JSON.parse(localStorage.getItem('sh-userInfo')).uid || '',
    platform: 'pcweb',
  };
}
